import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCashRegister = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M13 21H6C5.47 21 4.961 20.789 4.586 20.414C4.211 20.039 4 19.53 4 19V9C4 8.47 4.211 7.961 4.586 7.586C4.961 7.211 5.47 7 6 7H8M20 10.12V9C20 8.47 19.789 7.961 19.414 7.586C19.039 7.211 18.53 7 18 7H16M16 10V4C16 3.47 15.789 2.961 15.414 2.586C15.039 2.211 14.53 2 14 2H10C9.47 2 8.961 2.211 8.586 2.586C8.211 2.961 8 3.47 8 4V10M16 10H8M16 10H17M8 10H7M8 14V14.01M8 17V17.01M12 13.99V14M12 17V17.01",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M22 15.1429C21.5158 14.5916 20.9023 14.2187 20.2364 14.071C19.5706 13.9233 18.882 14.0072 18.2571 14.3123C17.6321 14.6175 17.0986 15.1302 16.7234 15.7862C16.3482 16.4422 16.1481 17.2124 16.1481 18C16.1481 18.7876 16.3482 19.5578 16.7234 20.2138C17.0986 20.8698 17.6321 21.3825 18.2571 21.6877C18.882 21.9928 19.5706 22.0767 20.2364 21.929C20.9023 21.7813 21.5158 21.4084 22 20.8571M19.5901 16.8571H15M15 19.1429H19.5901",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgCashRegister;
